import React, { useEffect, useState } from "react";
import { Box, Container, Grid, Paper } from "@mui/material";
import apis from "services";
import { DataGrid } from "@mui/x-data-grid";
import WithDrawlTable from "components/datagrid/WithDrawlTable";
import { toast } from "react-toastify";
import useNavigate from "hooks/Navigate";
import AdminNewSidebar from "components/admin/AdminNewSidebar";
import { Header } from "components";
import { useTranslation } from "react-i18next";
import { Button, Col, Form, Row } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { setWallet } from "redux/slices/walletSlicer";
import { setAdmin } from "redux/slices/adminSlice";

const SubAdminWithDrawl = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { wallet } = useSelector((store) => store.wallet);

  const { adminUser } = useSelector((store) => store.admin);
  const [withDrawl, setWithDrawl] = useState([]);

  useEffect(() => {
    if (adminUser) {
      setData((prevState) => ({
        ...prevState,
        userId: adminUser?._id,
        adminId: adminUser?._id,
        amount: "",
        walletId: adminUser?.wallet?._id,
        type: adminUser?.type,
      }));
    }
  }, []);

  const [data, setData] = useState({
    userId: adminUser?._id,
    adminId: adminUser?._id,
    walletId: adminUser?.wallet?._id,
    amount: "",
    type: adminUser?.type,
  });

  const fetchAllWithDrawlUser = async () => {
    const res = await apis.getUserWithdrawl(adminUser?._id);
    setWithDrawl(res?.data?.withDrawl);
  };

  const handleCancelWithDrawl = async (id) => {
    const res = await apis.cancelWithdrawl(id);
    if (res?.data?.status) {
      dispatch(setAdmin(res.data?.wallet));
      toast.success(res.data?.message);
      await fetchAllWithDrawlUser();
    } else toast.error(res.data?.message);
  };

  useEffect(() => {
    (async () => {
      await fetchAllWithDrawlUser();
    })();
  }, []);

  const methods = {
    navigate,
    handleCancelWithDrawl,
  };

  const { rows, columns } = WithDrawlTable(withDrawl, methods);
  const onChangeHandler = (e) => {
    const { name, value } = e.target;
    setData((prevState) => ({ ...prevState, [name]: value }));
  };

  const submit = async (e) => {
    e.preventDefault();
    const res = await apis.addWithdrawl(data);
    if (res?.data?.status) {
      dispatch(setAdmin(res.data?.wallet));
      toast.success(res.data?.message);
      setData((prev) => ({ ...prev, amount: "" }));
      await fetchAllWithDrawlUser();
    } else {
      toast.error(res.data?.message);
      setData((prev) => ({ ...prev, amount: "" }));
    }
  };

  return (
    <>
      <Box className="dashboard-main">
        <AdminNewSidebar />
        <div className="dashboard-section-main">
          <Box
            component="main"
            sx={{
              flexGrow: 1,
              height: "100vh",
              overflow: "auto",
            }}
            className="custom-scroll"
          >
            <Header />
            <Container sx={{ mt: 4, mb: 4 }} className="mainContainerComp">
              <div class="container-withdrawl">
                <Grid xs={12} sm={12} md={12} lg={12}>
                  <Paper
                    style={{ width: "100%" }}
                    sx={{
                      p: 2,
                      display: "flex",
                      flexDirection: "column",
                    }}
                    className="dashboard-box"
                  >
                    <h3 className="text-center balance-withdrawl">
                      {t("labels.balance")}
                    </h3>
                    <h4 className="text-center balance-withdrawl">
                      {adminUser?.wallet?.dividend?.toFixed(3) || 0}
                    </h4>
                  </Paper>
                </Grid>
                <div class="content-withdrawl">
                  <h3 className="dashboard-title">{t("titles.withDrawl")}</h3>
                </div>
              </div>

              <Form onSubmit={submit} className="">
                <Row className="d-flex justify-content-center align-items-center">
                  <Col xs={12} md={12} lg={6}>
                    <Form.Group className="mb-2" controlId="title">
                      <Form.Label>{t("titles.enter_amount")}</Form.Label>
                      <Form.Control
                        required
                        type="number"
                        name="amount"
                        placeholder={t(
                          "placeholders.enter_request_withdrawl_amount"
                        )}
                        onChange={onChangeHandler}
                        value={data.amount}
                      />
                    </Form.Group>
                  </Col>
                  <Col xs={12} md={6} lg={6}>
                    <Button
                      className="lp-btn mt-4"
                      variant="outline-danger"
                      type="submit"
                    >
                      {" "}
                      {t("buttons.submit")}
                    </Button>
                  </Col>
                </Row>
              </Form>
              <Grid
                item
                container
                justifyContent="flex-end"
                className="mt-4"
                sx={{ height: "600px", position: "relative", zIndex: "1" }}
              >
                <DataGrid
                  rows={rows}
                  columns={columns}
                  getRowClassName={(params) =>
                    params.indexRelativeToCurrentPage % 2 === 0 ? "even" : "odd"
                  }
                />
                <img
                  src="/assets/images/frameCardBG.png"
                  alt="frameCardBG"
                  style={{
                    position: "absolute",
                    bottom: "-46px",
                    left: "-24px",
                    width: "296px",
                    zIndex: "-1",
                  }}
                  className="card-bg-img"
                />
              </Grid>
            </Container>
          </Box>
        </div>
      </Box>
    </>
  );
};

export default SubAdminWithDrawl;
